import {Row} from "react-bootstrap";
import React from "react";
import {FaGithub, FaInstagram, FaLinkedinIn} from 'react-icons/fa';
import './SocialUtil.css';
import {portfolioData} from "../../../data/data";
const SocialUtil = () => <Row className={'flex-column social'}>
    <ul style={{listStyle: 'none'}} className={'social-list'}>
        <li className={'mb-2'}>
            <a href={portfolioData.github} style={{color: '#333'}}><FaGithub/></a>
        </li>
        <li className={'mb-2'}>
            <a href={portfolioData.instagram} style={{color: '#e24572'}}><FaInstagram/></a>
        </li>
        <li className={'mb-4'}>
            <a href={portfolioData.linkedin}><FaLinkedinIn/></a>
        </li>
    </ul>
</Row>;

export default SocialUtil;